import helpers from '@router/helpers';
const menuId = 'ajuda';

export default [
    helpers.criarRota(
        menuId,
        'ajuda',
        `${menuId}/:moduleName(.*)*`,
        () => import('@/views/modulos/ajuda/index.vue'),
        true
    ),
    helpers.criarRota(
        menuId,
        'ajuda',
        `${menuId}/`,
        () => import('@/views/modulos/ajuda/index.vue'),
        true
    )
]